// EmailJS Configuration
// Follow these steps to set up EmailJS:

// 1. Go to https://www.emailjs.com/ and create a free account
// 2. Create a new service (Gmail, Outlook, etc.) and note the Service ID
// 3. Create email templates and note the Template IDs
// 4. Get your Public Key from the Integration section

export const EMAIL_CONFIG = {
  // EmailJS Configuration - Complete setup
  SERVICE_ID: 'service_z0lx2sl', // Gmail Service ID
  TEMPLATE_ID: 'template_945cake', // Contact Us Template ID
  AUTO_REPLY_TEMPLATE_ID: 'your_auto_reply_template_id', // Optional auto-reply template
  PUBLIC_KEY: 'whIo7f8J4IPYRA5cR', // Public Key
  PRIVATE_KEY: 'FXx2zXURq8YmgPOfkunMA' // Private Key (keep secure)
};

// Email template variables you can use:
// {{from_name}} - User's name
// {{from_email}} - User's email
// {{phone}} - User's phone
// {{company}} - User's company
// {{service}} - Selected service
// {{message}} - User's message
// {{to_email}} - Your email (info@sutrasync.com)
// {{reply_to}} - User's email for replies

/* 
SETUP INSTRUCTIONS:

1. Create EmailJS Account:
   - Go to https://emailjs.com
   - Sign up for free account
   - Verify your email

2. Add Email Service:
   - Go to Email Services
   - Click "Add New Service"
   - Choose your email provider (Gmail recommended)
   - Follow setup instructions
   - Note the Service ID

3. Create Email Template:
   - Go to Email Templates
   - Click "Create New Template"
   - Use this template structure:

   Subject: New Contact Form Submission from {{from_name}}
   
   Body:
   You have received a new contact form submission:
   
   Name: {{from_name}}
   Email: {{from_email}}
   Phone: {{phone}}
   Company: {{company}}
   Service: {{service}}
   
   Message:
   {{message}}
   
   Reply to: {{reply_to}}

4. Create Auto-Reply Template (Optional):
   Subject: Thank you for contacting Sutrasync
   
   Body:
   Dear {{to_name}},
   
   Thank you for contacting Sutrasync! We have received your message and will get back to you within 24 hours.
   
   Our team is excited to learn more about your project and how we can help bring your digital vision to life.
   
   Best regards,
   The Sutrasync Team
   info@sutrasync.com
   +91 7483961283

5. Get Public Key:
   - Go to Account > General
   - Copy your Public Key

6. Update Configuration:
   - Replace the values in emailService.js with your actual IDs and key
*/